import React from 'react'

import EntityPage from '../components/EntityPage'
import StatusBadge from '../components/StatusBadge'
import { fmtDate, fmtTime } from '../components/format'
import { usePersonLabels, joinLabels } from '../api/people'

const Flights: React.FC = () => {
  const labels = usePersonLabels()

  return (
    <EntityPage
      entity="flights"
      title="✈️ Flights"
      description="One row per flight leg. Times are local Costa Rica time (UTC-6, no DST)."
      addLabel="Add flight"
      emptyHint="No flights yet — add the first one."
      columns={[
        { key: 'traveler_ids', label: 'Travelers', render: (r) => joinLabels(labels, r.traveler_ids) },
        { key: 'direction', label: 'Direction', render: (r) => <StatusBadge status={r.direction} /> },
        { key: 'date', label: 'Date', render: (r) => fmtDate(r.date) },
        { key: 'time_local', label: 'Time', render: (r) => fmtTime(r.time_local) },
        { key: 'airline', label: 'Airline' },
        { key: 'flight_number', label: 'Flight #' },
        { key: 'route', label: 'Route' },
        { key: 'airport', label: 'Airport' },
        { key: 'confirmation', label: 'Conf #' },
        { key: 'notes', label: 'Notes' },
      ]}
      fields={[
        { name: 'traveler_ids', label: 'Travelers', type: 'people' },
        {
          name: 'direction', label: 'Direction', type: 'select', required: true,
          options: [{ value: 'arrival', label: 'Arrival' }, { value: 'departure', label: 'Departure' }],
        },
        { name: 'date', label: 'Date', type: 'date', required: true },
        { name: 'time_local', label: 'Time (Costa Rica local)', type: 'time', required: true },
        { name: 'airline', label: 'Airline', type: 'text' },
        { name: 'flight_number', label: 'Flight #', type: 'text', placeholder: 'UA1234' },
        { name: 'route', label: 'Route', type: 'text', placeholder: 'ORD → SJO' },
        {
          name: 'airport', label: 'Airport', type: 'select', required: true,
          options: [{ value: 'SJO', label: 'SJO — San José' }, { value: 'LIR', label: 'LIR — Liberia' }],
        },
        { name: 'confirmation', label: 'Confirmation #', type: 'text' },
        { name: 'notes', label: 'Notes', type: 'textarea' },
      ]}
      blank={{ direction: 'arrival', airport: 'SJO' }}
    />
  )
}

export default Flights
